import { render, staticRenderFns } from "./fdeclarelist.vue?vue&type=template&id=e56c29bc&scoped=true"
import script from "./fdeclarelist.vue?vue&type=script&lang=js"
export * from "./fdeclarelist.vue?vue&type=script&lang=js"
import style0 from "./fdeclarelist.vue?vue&type=style&index=0&id=e56c29bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56c29bc",
  null
  
)

export default component.exports